/* eslint-disable @typescript-eslint/no-explicit-any */
import { all, takeLatest, call, put, delay } from 'redux-saga/effects';

import Api from '../../../services/api';

import {
  ActionTypes,
  SignInRequestAction,
  SignUpRequestAction,
  ResetPasswordRequestAction,
  ForgotPasswordRequestAction,
  FacebookSignInRequestAction,
} from './types';

import {
  signInSuccess,
  signInFailure,
  resetPasswordSuccess,
  resetPasswordFailure,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from './actions';

import { getSignInErrors, getSignUpErrors } from '../../../utils/errors';

function* signInRequest(
  action: SignInRequestAction,
): Generator<any, void, string> {
  try {
    const response: string = yield call(Api.auth.signIn, action.payload);
    yield put(signInSuccess(response));
  } catch (err: any) {
    yield put(signInFailure(getSignInErrors(err)));
  }
}

function* signUpRequest(
  action: SignUpRequestAction,
): Generator<any, void, string> {
  try {
    const response: string = yield call(Api.auth.signUp, action.payload);
    yield put(signInSuccess(response));
  } catch (err: any | any[]) {
    const extractedErrors = getSignUpErrors(err);

    const messages = Array.isArray(extractedErrors)
      ? extractedErrors
      : [extractedErrors || 'O email já está em uso.'];

    // eslint-disable-next-line no-restricted-syntax
    for (const message of messages) {
      yield put(signInFailure(message));
      yield delay(1500);
    }
  }
}

function* resetPassword(action: ResetPasswordRequestAction) {
  try {
    yield call(Api.auth.resetPassword, action.payload);
    yield put(resetPasswordSuccess());
  } catch (err: any) {
    yield put(resetPasswordFailure(getSignInErrors(err)));
  }
}

function* forgotPassword(action: ForgotPasswordRequestAction) {
  try {
    yield call(Api.auth.forgotPassword, action.payload);
    yield put(forgotPasswordSuccess());
  } catch (err: any) {
    yield put(forgotPasswordFailure(getSignInErrors(err)));
  }
}

function* facebookSignInRequest(
  action: FacebookSignInRequestAction,
): Generator<any, void, string> {
  try {
    const response: string = yield call(
      Api.auth.facebookSignIn,
      action.payload,
    );
    yield put(signInSuccess(response));
  } catch (err: any) {
    yield put(signInFailure(err.response.data?.errors?.messages[0]));
  }
}

export default all([
  takeLatest(ActionTypes.SIGN_IN_REQUEST, signInRequest),
  takeLatest(ActionTypes.SIGN_UP_REQUEST, signUpRequest),
  takeLatest(ActionTypes.RESET_PASSWORD_REQUEST, resetPassword),
  takeLatest(ActionTypes.FORGOT_PASSWORD_REQUEST, forgotPassword),
  takeLatest(ActionTypes.FACEBOOK_SIGN_IN_REQUEST, facebookSignInRequest),
]);
